import handler from './responseHandler'
import dd from "./dd";

const jumper = {

    //Backend for frontend
    bff(component, entrypoint, payload, callback) {
        return window.axios
            .post(`/_jumper/message/${entrypoint}`, payload)
            .then(response => {
                if (handler.mustStopHandling(response)) {
                    return response
                }
                return handler.jumper(component, response)
            })
            .catch(error => {
                if (error.response && dd.isOutputFromDump(error.response.data)) {
                    dd.showHtmlModal(error.response.data)
                    return error
                }
                if (handler.mustStopHandlingError(error)) {
                    return error
                }
                return handler.jumperError(component, error)
            })
    },

    // TODO delete or "transfer" to datasets helpers
    getSafe(object, dotNotationString) {
        return dotNotationString.split('.').reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, object)
    },
}
window.Jumper = jumper
export {jumper}
export default jumper
